








import { Vue, Component } from 'vue-property-decorator'
import Main from './components/Main/index.vue'
import { MainHead, HeadTabs } from '@/components/index'

@Component({
  components: {
    MainHead,
    HeadTabs,
    Main
  }
})
export default class extends Vue {
  // 头部数据
  headData: string[] = [
    '按照业务维度创建并维护对象，在分群管理和运营计划管理中引用它们。',
    '在创建和维护分群前，请先选择对象：'
  ]
  headTitle: string = '对象管理'
  HeadImg: string = require('@/assets/images/add_object.png')
}
